/* Viego — pop-up de boas-vindas (Claude, 25/10/2026). Configuração vem dos atributos data-* da seção sections/popup.liquid. */
(function () {
  if (!window.customElements || customElements.get('viego-popup')) return;

  function guarda(tipo) {
    return {
      get: function (k) { try { return window[tipo].getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { window[tipo].setItem(k, v); } catch (e) {} },
      del: function (k) { try { window[tipo].removeItem(k); } catch (e) {} }
    };
  }
  var LS = guarda('localStorage'), SS = guarda('sessionStorage');
  var reduz = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function celular() { return matchMedia('(max-width: 767px)').matches; }
  function dl(o) { (window.dataLayer = window.dataLayer || []).push(o); }

  // o CSS carrega sem bloquear a página (media="print"); nada aparece antes dele
  function cssPronto(cb) {
    var l = document.getElementById('viego-popup-css'), feito = false;
    function vai() { if (feito) return; feito = true; if (l) l.media = 'all'; cb(); }
    if (!l || l.media === 'all') return vai();
    l.addEventListener('load', vai);
    setTimeout(vai, 4000);
  }

  // e-mails digitados errado (gmail.con, hotmial.com, yahoo.com.b...) -> sugestão de correção
  var VALIDOS = {gmail: ['gmail.com'], hotmail: ['hotmail.com', 'hotmail.com.br'], outlook: ['outlook.com', 'outlook.com.br'], yahoo: ['yahoo.com.br', 'yahoo.com'],
    icloud: ['icloud.com'], live: ['live.com'], bol: ['bol.com.br'], uol: ['uol.com.br'], terra: ['terra.com.br']};
  var ERROS = {gmai: 'gmail', gmial: 'gmail', gamil: 'gmail', gnail: 'gmail', gmaill: 'gmail', gmal: 'gmail', gemail: 'gmail', gmali: 'gmail',
    hotmai: 'hotmail', hotmial: 'hotmail', hotmal: 'hotmail', homail: 'hotmail', hotmaill: 'hotmail', hotamil: 'hotmail',
    outlok: 'outlook', outloock: 'outlook', outlool: 'outlook', yaho: 'yahoo', yahooo: 'yahoo', iclod: 'icloud', icoud: 'icloud'};
  // provedores reais com nome parecido com os grandes (não sugerir troca para eles)
  var OUTROS_OK = ['mail.com', 'email.com', 'gmx.com', 'gmx.net', 'proton.me', 'protonmail.com', 'zoho.com', 'aol.com', 'ymail.com',
    'rocketmail.com', 'globo.com', 'globomail.com', 'ig.com.br', 'r7.com', 'oi.com.br', 'msn.com', 'me.com', 'mac.com'];
  // e-mails temporários e de teste: não recebem o cupom e estragam a reputação de envio
  var BLOQUEADOS = ['mailinator.com', 'yopmail.com', 'yopmail.net', 'guerrillamail.com', 'guerrillamail.net', 'sharklasers.com',
    '10minutemail.com', '10minutemail.net', 'temp-mail.org', 'temp-mail.io', 'tempmail.com', 'tempmail.net', 'tempail.com',
    'trashmail.com', 'getnada.com', 'nada.email', 'maildrop.cc', 'dispostable.com', 'throwawaymail.com', 'fakeinbox.com',
    'mintemail.com', 'mailnesia.com', 'emailondeck.com', 'mohmal.com', 'minuteinbox.com', 'burnermail.io', 'discard.email',
    'example.com', 'example.org', 'example.net', 'exemplo.com', 'exemplo.com.br', 'teste.com', 'teste.com.br', 'test.com'];
  function distancia(a, b) {
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) d[i] = [i];
    for (j = 0; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++) {
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
    return d[a.length][b.length];
  }
  function parecido(base) {   // hitmsil -> hotmail, igmail -> gmail
    if (base.length < 5) return null;
    var melhor = null, menor = 3;
    ['gmail', 'hotmail', 'outlook', 'yahoo', 'icloud'].forEach(function (p) { var x = distancia(base, p); if (x < menor) { menor = x; melhor = p; } });
    return melhor;
  }
  function sugerir(email) {
    var i = email.lastIndexOf('@'); if (i < 1) return null;
    var u = email.slice(0, i), d = email.slice(i + 1), base = d.split('.')[0], resto = d.slice(base.length);
    var prov = VALIDOS[base] ? base : ERROS[base];
    if (!prov && OUTROS_OK.indexOf(d) < 0) prov = parecido(base);
    if (prov) {
      var ok = VALIDOS[prov];
      if (ok.indexOf(d) > -1) return null;
      var alvo = ok.filter(function (v) { return v.slice(prov.length) === resto; })[0] ||
        (/\.b/.test(resto) && ok.filter(function (v) { return /\.br$/.test(v); })[0]) || ok[0];
      return u + '@' + alvo;
    }
    var f = d.replace(/\.(con|cm|vom|xom|cpm|comm|cim|coom|clm|ocm|cpom|comg|coml|cok|c0m|comn|ccom)$/, '.com').replace(/\.(com\.(b|bt|be|brr|bf)|con\.br|cm\.br|vom\.br)$/, '.com.br');
    return f !== d ? u + '@' + f : null;
  }

  // confere no DNS público se o domínio existe e recebe e-mail (só o domínio sai do navegador, nunca o e-mail).
  // Se a consulta falhar ou demorar (rede, bloqueador), o cadastro segue: nunca perdemos um cliente real por isso.
  var GRANDES = ['gmail.com', 'hotmail.com', 'hotmail.com.br', 'outlook.com', 'outlook.com.br', 'yahoo.com.br', 'yahoo.com',
    'icloud.com', 'live.com', 'bol.com.br', 'uol.com.br', 'terra.com.br'];
  function dns(nome, tipo) {
    var c = window.AbortController ? new AbortController() : null, t = setTimeout(function () { if (c) c.abort(); }, 2500);
    function json(r) { return r.json(); }
    var q = '?name=' + encodeURIComponent(nome) + '&type=' + tipo;
    return fetch('https://cloudflare-dns.com/dns-query' + q, {headers: {accept: 'application/dns-json'}, signal: c && c.signal}).then(json)
      .catch(function () { return fetch('https://dns.google/resolve' + q, {signal: c && c.signal}).then(json); })
      .then(function (r) { clearTimeout(t); return r; }, function (e) { clearTimeout(t); throw e; });
  }
  function dominioRecebe(d) {
    if (GRANDES.indexOf(d) > -1) return Promise.resolve('ok');
    var salvo = SS.get('vpp_dns_' + d);
    if (salvo) return Promise.resolve(salvo);
    function guarda(v) { if (v !== '?') SS.set('vpp_dns_' + d, v); return v; }
    return dns(d, 'MX').then(function (r) {
      if (r.Status === 3 || r.Status === 2) return guarda('nao');      // domínio não existe / DNS quebrado
      if (r.Status !== 0) return '?';
      var mx = (r.Answer || []).filter(function (a) { return a.type === 15; }).map(function (a) { return String(a.data).trim(); });
      if (mx.length) {
        var serve = mx.some(function (m) { return !/^\d+\s+(\.|localhost\.?|127\.)/.test(m); });
        return guarda(serve ? 'ok' : 'nao');
      }
      return dns(d, 'A').then(function (ra) { return guarda((ra.Answer || []).some(function (a) { return a.type === 1; }) ? 'ok' : 'nao'); });
    }).catch(function () { return '?'; });
  }

  // nome obrigatório: aceita acentos, sobrenome, hífen e apóstrofo; recusa e-mail, números e símbolos (devolve a mensagem de erro)
  function problemaNome(n) {
    if (!n) return 'Digite seu primeiro nome para liberar o seu desconto.';
    if (n.indexOf('@') > -1) return 'Digite seu nome aqui. O e-mail vai no campo de baixo.';
    if (/\d/.test(n)) return 'Use só letras no seu nome.';
    if (/[_=+<>\/\\:;#$%&*()\[\]{}|~^"!?,]/.test(n) || /www\.|\.(com|net|org|br)\b/i.test(n)) return 'Digite só o seu nome.';
    if (n.replace(/[\s.'’`´-]/g, '').length < 2) return 'Digite seu primeiro nome.';
    return '';
  }

  function digitos(v) { return (v || '').replace(/\D/g, ''); }
  function mascaraTel(v) {
    var d = digitos(v).replace(/^55(?=\d{10,11}$)/, '').slice(0, 11);
    if (!d) return '';
    if (d.length <= 2) return '(' + d;
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }

  class ViegoPopup extends HTMLElement {
    static get observedAttributes() { return ['open']; }
    get open() { return this.hasAttribute('open'); }
    set open(v) { if (v) this.setAttribute('open', ''); else this.removeAttribute('open'); }

    connectedCallback() {
      if (this._pronto) return;
      this._pronto = true;
      var self = this, d = this.dataset;
      this.caixa = this.querySelector('.vpp-caixa');
      this.form = this.querySelector('form');
      this.email = this.querySelector('[data-vpp-email]');
      this.nome = this.querySelector('[data-vpp-nome-campo]');
      this.tel = this.querySelector('[data-vpp-tel]');
      this.telAceite = this.querySelector('[data-vpp-tel-aceite]');
      this.tags = this.querySelector('[data-vpp-tags]');
      this.btn = this.querySelector('[data-vpp-enviar]');
      this.teaser = document.getElementById('vpp-teaser');
      this.dias = d.dias === 'nunca' ? 0 : Math.max(1, +d.dias || 7);
      this._tecla = this._tecla.bind(this);
      this._envio = function (e) {
        if (e.target !== self.form) return;
        e.preventDefault(); e.stopImmediatePropagation();
        self.enviar();
      };
      this.form.noValidate = true;
      // sinal de uso real: gesto verdadeiro (isTrusted) dentro do formulário com o pop-up aberto. Ver usoReal().
      ['pointerdown', 'touchstart', 'keydown', 'input'].forEach(function (t) {
        self.form.addEventListener(t, function (e) { if (e.isTrusted && self.open) self._gesto = true; }, {capture: true, passive: true});
      });

      this.addEventListener('click', function (e) {
        var a = e.target.closest('[data-vpp-fechar],[data-vpp-copiar],[data-vpp-cta],[data-vpp-usar]');
        if (!a) return;
        if (a.hasAttribute('data-vpp-fechar')) self.fechar(a.getAttribute('data-vpp-fechar') || 'x');
        else if (a.hasAttribute('data-vpp-copiar')) self.copiar(a);
        else if (a.hasAttribute('data-vpp-cta')) self.cta();
        else if (a.hasAttribute('data-vpp-usar')) { self.email.value = a.textContent; self.dica(''); self.email.focus(); }
      });
      // A Shopify liga nos formulários de cadastro um script que reenvia o formulário do jeito tradicional. Tratamos o
      // envio antes dele (fase de captura) e só usamos o envio dele (form.submit) quando ela pede a verificação anti-robô.
      document.addEventListener('submit', this._envio, true);
      this.email.addEventListener('input', function () { self.email.removeAttribute('aria-invalid'); self.erro(''); });
      if (this.nome) this.nome.addEventListener('input', function () { self.nome.removeAttribute('aria-invalid'); self.erro(''); });
      if (this.tel) this.tel.addEventListener('input', function () { self.tel.value = mascaraTel(self.tel.value); self.tel.removeAttribute('aria-invalid'); self.erro(''); });
      this.arrastar();

      if (this.teaser) {
        this.teaser.addEventListener('click', function (e) {
          if (e.target.closest('[data-vpp-teaser-x]')) {
            LS.set('vpp_teaser_off', Date.now()); self.teaserVer(false);
            dl({event: 'viego_popup', popup_acao: 'teaser_dispensado'});
          } else if (e.target.closest('[data-vpp-teaser-abrir]')) {
            LS.del('vpp_teaser_n'); self.abrir('teaser');
          }
        });
      }

      if (window.Shopify && Shopify.designMode) {
        var minha = function (e) { return e.target.contains(self); };
        this._editor = {
          select: function (e) { if (minha(e)) self.abrir('editor'); },
          load: function (e) { if (minha(e)) self.abrir('editor'); },
          deselect: function (e) { if (minha(e)) self.open = false; }
        };
        document.addEventListener('shopify:section:select', this._editor.select);
        document.addEventListener('shopify:section:load', this._editor.load);
        document.addEventListener('shopify:section:deselect', this._editor.deselect);
        if (d.editorTela === 'cupom') this.passo2('João');
        return;
      }
      cssPronto(function () { self.iniciar(); });
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this._envio, true);
      document.removeEventListener('keydown', this._tecla);
      document.documentElement.classList.remove('vpp-trava');
      if (this._editor) {
        document.removeEventListener('shopify:section:select', this._editor.select);
        document.removeEventListener('shopify:section:load', this._editor.load);
        document.removeEventListener('shopify:section:deselect', this._editor.deselect);
      }
    }

    iniciar() {
      var url = new URL(location.href), p = url.searchParams;
      if (p.get('customer_posted') === 'true') {
        LS.set('vpp_inscrito', '1');
        if (SS.get('vpp_enviando')) {          // voltou da verificação anti-robô da Shopify: mostra o cupom
          SS.del('vpp_enviando');
          this.passo2(SS.get('vpp_nome') || '');
          p.delete('customer_posted');
          history.replaceState(history.state, '', url.pathname + (p.toString() ? '?' + p.toString() : ''));
          this.contarCadastro('verificacao');
          this.abrir('retorno');
          return;
        }
      }
      var forca = p.get('viego_popup');
      if (forca === 'lembrete') { this.teaserVer(true, true); return; }
      if (forca || location.hash === '#viego-popup') { if (forca === 'cupom') this.passo2(''); this.abrir('teste'); return; }
      if (LS.get('vpp_inscrito')) return;
      if (this.recente('vpp_fechado') || SS.get('vpp_visto')) { this.teaserVer(true); return; }
      if (this.dataset.auto !== 'true') return;
      this.agendar();
    }

    recente(chave) {
      var t = +LS.get(chave) || 0;
      if (!t) return false;
      return this.dias === 0 || Date.now() - t < this.dias * 864e5;
    }

    agendar() {
      var self = this, d = this.dataset, t0 = Date.now(), feito = false, mob = celular();
      var discreto = d.modo === 'discreto';
      var atraso = Math.max(0, +d.atraso || 0) * 1000;
      var rolagem = discreto ? 0 : (+d.rolagem || 0) / 100;
      function ocupado() {
        var a = document.activeElement;
        if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !self.contains(a)) return true;
        if (document.documentElement.classList.contains('lock-all')) return true;
        return !!document.querySelector('drawer-content[open], mini-cart[open], modal-content[open], popover-content[open], mobile-navigation[open], quick-buy-drawer[open]');
      }
      function tentar(motivo) {
        if (feito) return;
        if (ocupado()) { setTimeout(function () { tentar(motivo); }, 4000); return; }
        feito = true; limpar(); self.abrir(motivo);
      }
      function rolou() {
        if (Date.now() - t0 < 4000) return;
        var h = document.documentElement;
        if ((h.scrollTop + innerHeight) / Math.max(1, h.scrollHeight) >= rolagem) tentar('rolagem');
      }
      function saida(e) { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 3000) tentar('saida'); }
      var espera = mob ? Math.max(atraso, discreto ? 20000 : 8000) : atraso;
      var timer = (mob || !discreto) ? setTimeout(function () { tentar('tempo'); }, espera) : 0;
      var tMidia = (mob || !discreto) ? setTimeout(function () { self.midia(); }, Math.max(0, espera - 2000)) : 0;
      if (!mob && !discreto) document.addEventListener('mousemove', function m() { document.removeEventListener('mousemove', m); setTimeout(function () { self.midia(); }, 3000); });
      if (mob && rolagem > 0) addEventListener('scroll', rolou, {passive: true});
      if (!mob && d.saida === 'true') document.addEventListener('mouseout', saida);
      function limpar() { clearTimeout(timer); clearTimeout(tMidia); removeEventListener('scroll', rolou); document.removeEventListener('mouseout', saida); }
    }

    abrir(motivo) { this.motivo = motivo || 'manual'; this.open = true; }

    // o banner fica num <template> e só é baixado perto da hora de abrir (não pesa em quem nunca vê o pop-up)
    midia() {
      var t = this.querySelector('template[data-vpp-midia]');
      if (t) t.replaceWith(t.content.cloneNode(true));
    }

    attributeChangedCallback(nome, antes, agora) {
      if (nome !== 'open' || (antes === null) === (agora === null)) return;
      if (agora !== null) this._mostrar(); else this._esconder();
    }

    _mostrar() {
      var self = this;
      clearTimeout(this._tEsconde);
      this.focoAntes = document.activeElement;
      this._abertoEm = Date.now();
      this.midia();
      this.caixa.style.transform = '';
      this.hidden = false;
      this.getBoundingClientRect();
      requestAnimationFrame(function () { self.classList.add('vpp-aberto'); });
      document.documentElement.classList.add('vpp-trava');
      document.addEventListener('keydown', this._tecla);
      this.teaserVer(false);
      if (this.motivo !== 'editor') {
        SS.set('vpp_visto', '1');
        dl({event: 'viego_popup', popup_acao: 'exibido', popup_motivo: this.motivo || 'manual'});
      }
      setTimeout(function () {
        var alvo = self.querySelector('[data-passo="2"]:not([hidden]) [data-vpp-copiar]') ||
          (!celular() && self.motivo !== 'editor' && self.querySelector('[data-passo="1"] input:not([type=hidden])')) || self.caixa;
        try { alvo.focus({preventScroll: true}); } catch (e) {}
      }, reduz ? 0 : 380);
    }

    _esconder() {
      var self = this;
      this.classList.remove('vpp-aberto');
      document.documentElement.classList.remove('vpp-trava');
      document.removeEventListener('keydown', this._tecla);
      this._tEsconde = setTimeout(function () { if (!self.open) self.hidden = true; }, reduz ? 0 : 420);
      if (this.focoAntes && this.focoAntes.focus && document.contains(this.focoAntes)) { try { this.focoAntes.focus({preventScroll: true}); } catch (e) {} }
    }

    fechar(como) {
      if (!this.open) return;
      this.open = false;
      if (this.motivo === 'editor') return;
      if (!LS.get('vpp_inscrito')) {
        LS.set('vpp_fechado', Date.now());
        this.teaserVer(true);
      }
      dl({event: 'viego_popup', popup_acao: 'fechado', popup_via: como || 'x'});
    }

    teaserVer(sim, forcar) {
      var t = this.teaser, self = this;
      if (!t) return;
      if (!sim) {
        if (t.hidden) return;
        t.classList.remove('vpp-on');
        setTimeout(function () { if (!t.classList.contains('vpp-on')) t.hidden = true; }, reduz ? 0 : 450);
        return;
      }
      if (!forcar) {
        if (LS.get('vpp_inscrito') || this.recente('vpp_teaser_off')) return;
        var limite = +t.dataset.limite || 0;
        if (limite) {
          var n = +LS.get('vpp_teaser_n') || 0;
          if (!SS.get('vpp_teaser_contou')) { n++; LS.set('vpp_teaser_n', n); SS.set('vpp_teaser_contou', '1'); }
          if (n > limite) return;
        }
      }
      t.hidden = false; t.getBoundingClientRect();
      requestAnimationFrame(function () { t.classList.add('vpp-on'); });
      if (celular() && !this._teaserCel) {
        this._teaserCel = true;
        // no celular: depois de alguns segundos fica só o presente, pulsando (continua visível ao rolar a página)
        setTimeout(function () { t.classList.add('vpp-mini'); }, 6000);
      }
      if (!this._teaserContado) { this._teaserContado = true; dl({event: 'viego_popup', popup_acao: 'lembrete_exibido'}); }
    }

    arrastar() {   // celular: arrastar o topo do pop-up para baixo fecha
      var self = this, c = this.caixa, y0 = null, dy = 0;
      c.addEventListener('touchstart', function (e) {
        if (!celular() || c.scrollTop > 0 || !e.target.closest('.vpp-foto, .vpp-alca')) { y0 = null; return; }
        y0 = e.touches[0].clientY; dy = 0;
      }, {passive: true});
      c.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        dy = Math.max(0, e.touches[0].clientY - y0);
        c.classList.add('vpp-arrasto'); c.style.transform = 'translateY(' + dy + 'px)';
      }, {passive: true});
      c.addEventListener('touchend', function () {
        if (y0 === null) return;
        c.classList.remove('vpp-arrasto'); c.style.transform = '';
        if (dy > 90) self.fechar('arrastou');
        y0 = null;
      });
    }

    _tecla(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.fechar('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(this.caixa.querySelectorAll('button, input, a[href]'), function (n) {
        return n.type !== 'hidden' && !n.closest('[hidden]') && n.offsetParent !== null;
      });
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && (i === f.length - 1 || i === -1)) { e.preventDefault(); f[0].focus(); }
    }

    erro(msg, campo) {
      var el = this.querySelector('[data-vpp-erro]');
      el.textContent = msg; el.hidden = !msg;
      if (msg) (campo || this.email).setAttribute('aria-invalid', 'true');
    }
    dica(sug) {
      var el = this.querySelector('[data-vpp-dica]');
      el.hidden = !sug; el.textContent = '';
      if (!sug) return;
      el.appendChild(document.createTextNode('Você quis dizer '));
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-vpp-usar', ''); b.textContent = sug;
      el.appendChild(b); el.appendChild(document.createTextNode('?'));
    }
    carregando(sim, texto) {
      this.btn.disabled = sim;
      var r = this.btn.querySelector('[data-vpp-rotulo]');
      if (this._rot === undefined) this._rot = r.textContent;
      r.textContent = sim ? (texto || 'Liberando seu desconto…') : this._rot;
    }

    // Sem isto o cadastro vai sem tag e não entra no fluxo de boas-vindas (a tag não fica mais escrita no formulário).
    // 1,5 s desde a abertura: com o preenchimento automático do navegador, uma pessoa ainda precisa ver o pop-up e tocar no botão.
    usoReal() { return !!(this.open && this._gesto && Date.now() - (this._abertoEm || 0) >= 1500); }

    contarCadastro(via) {
      if (SS.get('vpp_sem_sinal')) { SS.del('vpp_sem_sinal'); dl({event: 'viego_popup', popup_acao: 'cadastro_sem_sinal'}); return; }
      dl({event: 'viego_popup', popup_acao: 'cadastro', popup_via: via});
      dl({event: 'generate_lead', lead_source: 'popup_boas_vindas'});
    }

    enviar() {
      if (this.btn.disabled) return;
      var self = this;
      var email = this.email.value.trim().toLowerCase(); this.email.value = email;
      var nome = this.nome ? this.nome.value.trim().replace(/\s+/g, ' ') : '';
      if (this.nome) this.nome.value = nome;
      this.erro('');
      var ruimNome = this.nome ? problemaNome(nome) : '';
      if (ruimNome) { this.erro(ruimNome, this.nome); this.nome.focus(); return; }
      if (!/^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,24}$/.test(email)) {
        this.erro('Digite um e-mail válido para liberar o seu desconto.'); this.email.focus(); return;
      }
      var sug = sugerir(email);
      if (sug && this._ultimaSug !== email) { this._ultimaSug = email; this.dica(sug); this.email.focus(); return; }
      this.dica('');

      var tel = this.tel ? digitos(this.tel.value) : '';
      if (this.tel) {
        if (!tel && this.tel.required) { this.erro('Digite o seu WhatsApp com DDD.', this.tel); this.tel.focus(); return; }
        if (tel && (tel.length < 10 || tel.length > 11)) { this.erro('Confira o WhatsApp: DDD + número, ex.: (31) 99999-9999.', this.tel); this.tel.focus(); return; }
      }
      var real = this.usoReal();
      if (real) SS.del('vpp_sem_sinal'); else SS.set('vpp_sem_sinal', '1');
      var base = real ? (this.tags.getAttribute('data-base') || '') : '';
      var tags = base.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (tel && real) {
        tags.push('whatsapp');
        if (this.telAceite && this.telAceite.checked) tags.push('whatsapp-optin');
      }
      this.tags.value = tags.join(', ');

      var dominio = email.split('@')[1];
      if (BLOQUEADOS.indexOf(dominio) > -1) {
        this.erro('Use um e-mail que você acessa de verdade: e-mails temporários ou de teste não recebem o cupom.'); this.email.focus(); return;
      }
      this.carregando(true, 'Conferindo seu e-mail…');
      (this.dataset.validar === 'true' ? dominioRecebe(dominio) : Promise.resolve('ok')).then(function (res) {
        if (res === 'nao') {
          self.carregando(false);
          self.erro('Não encontramos esse e-mail. Confira se digitou certo (ex.: nome@gmail.com).');
          dl({event: 'viego_popup', popup_acao: 'email_recusado'});
          self.email.focus(); return;
        }
        self.carregando(true);
        SS.set('vpp_enviando', '1'); SS.set('vpp_nome', nome);
        self.postar(tel ? '+55' + tel : '', tel, tags);
      });
    }

    // tenta gravar o WhatsApp no telefone do cliente; se a Shopify recusar (número já usado por outro cliente, por
    // exemplo), envia de novo sem o telefone e guarda o número numa tag, para o cadastro nunca se perder
    postar(telefone, tel, tags) {
      var self = this, campo = this.querySelector('[data-vpp-tel-env]');
      if (campo) { campo.value = telefone; campo.disabled = !telefone; }
      this._telReserva = tel ? tags.concat('whatsapp-55' + tel).join(', ') : '';
      fetch(this.form.getAttribute('action') || '/contact', {method: 'POST', body: new FormData(this.form), credentials: 'same-origin', headers: {Accept: 'text/html'}})
        .then(function (r) {
          var u = r.url || '';
          if (/\/challenge/.test(u)) { self.envioNormal(); return; }
          if (/(customer|contact)_posted=true/.test(u)) { self.sucesso(self.nome ? self.nome.value : ''); return; }
          if (telefone) {
            self.tags.value = self._telReserva;
            self.postar('', tel, tags);
            return;
          }
          return r.text().then(function (html) {
            SS.del('vpp_enviando');
            self.carregando(false);
            var m = /data-vpp-erro-srv[^>]*>([^<]+)</.exec(html || '');
            self.erro(m ? m[1].trim() : 'Não conseguimos concluir agora. Confira o e-mail e tente de novo.');
          });
        })
        .catch(function () { self.envioNormal(); });
    }

    envioNormal() {   // a Shopify pediu verificação: envio normal da página, pelo mecanismo dela (volta com ?customer_posted=true)
      SS.set('vpp_enviando', '1');
      var f = this.form, campo = this.querySelector('[data-vpp-tel-env]');
      if (campo && !campo.disabled) { campo.disabled = true; this.tags.value = this._telReserva; }   // no envio normal o número vai só na tag
      if (typeof f.submit === 'function') f.submit(); else HTMLFormElement.prototype.submit.call(f);
    }

    sucesso(nome) {
      SS.del('vpp_enviando');
      LS.set('vpp_inscrito', '1'); LS.del('vpp_fechado');
      this.carregando(false);
      this.passo2(nome);
      this.contarCadastro('direto');
      var b =this.querySelector('[data-vpp-copiar]');
      setTimeout(function () { try { b.focus({preventScroll: true}); } catch (e) {} }, reduz ? 0 : 500);
    }

    passo2(nome) {
      this.querySelector('[data-passo="1"]').hidden = true;
      this.querySelector('[data-passo="2"]').hidden = false;
      var primeiro = (nome || '').split(' ')[0], alvo = this.querySelector('[data-vpp-nome]'), t2 = this.querySelector('[data-vpp-t2]');
      alvo.textContent = primeiro ? primeiro + ', ' : '';
      if (t2 && !t2._original) t2._original = t2.innerHTML;
      if (t2) {
        t2.innerHTML = t2._original;
        var no = t2.firstChild;
        if (primeiro && no && no.nodeType === 3) no.textContent = no.textContent.charAt(0).toLowerCase() + no.textContent.slice(1);
      }
      this.caixa.setAttribute('aria-labelledby', 'vpp-titulo2');
      this.classList.add('vpp-p2');
      this.teaserVer(false);
    }

    copiar(btn) {
      var cod = this.dataset.cupom, txt = btn.querySelector('[data-vpp-copiar-txt]'), self = this;
      function feito() {
        btn.classList.add('vpp-copiado'); txt.textContent = 'Copiado!';
        clearTimeout(self._tCop); self._tCop = setTimeout(function () { btn.classList.remove('vpp-copiado'); txt.textContent = 'Copiar'; }, 2200);
        dl({event: 'viego_popup', popup_acao: 'cupom_copiado'});
      }
      function reserva() {
        var t = document.createElement('textarea');
        t.value = cod; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
        document.body.appendChild(t); t.select();
        var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
        t.remove();
        if (ok) feito();
        else { var r = document.createRange(); r.selectNodeContents(self.querySelector('[data-vpp-codigo]')); var s = getSelection(); s.removeAllRanges(); s.addRange(r); txt.textContent = 'Selecionado'; }
      }
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(cod).then(feito, reserva); else reserva();
    }

    cta() {
      var link = this.dataset.cta;
      dl({event: 'viego_popup', popup_acao: 'cta'});
      if (link) location.href = link; else this.fechar('cta');
    }
  }
  customElements.define('viego-popup', ViegoPopup);
})();
